import React from "react";
import axios from "axios";
import { Table, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import GLOBALVAR from "../constants";
import LoadingSpinner from "../components/misc/LoadingSpinner";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import './css/ReportsStyles.scss'; 
import ToPeso from "../components/misc/ToPeso";
import logo from "../logo.png";

function ReportOutstandingBalancePerProduct() {
    const [showSpinner, setShowSpinner] = useState(false);
    const [endDate, setEndDate] = useState('');
    const [data, setData] = useState(null);

    const fetchOutstanding = async (endDate) => {
        setShowSpinner(true);

        try {
            const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/fetch/all/outstanding/byproduct`, {
                params: {
                    endDate: endDate || undefined
                }
            });

            setData(response.data);
            setShowSpinner(false);
        } catch (error) {
            console.error('Error fetching payments:', error);
            setShowSpinner(false);
        }
    };

    useEffect(() => {
        fetchOutstanding(endDate);
    }, [endDate]);

    const handleGeneratePDF = async () => {
        setShowSpinner(true);
        try {
            const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/fetch/all/outstanding/byproduct`, {
                params: {
                    endDate: endDate || undefined
                }
            });

            const doc = new jsPDF('landscape');

            // Function to center text
            const centerText = (text, y, fontWeight = 'normal') => {
                // Set font style
                doc.setFont(undefined, fontWeight);

                // Get page width
                const pageWidth = doc.internal.pageSize.getWidth();
                // Calculate the text width
                const textWidth = doc.getTextDimensions(text).w;
                // Calculate the text's X coordinate to be centered
                const textX = (pageWidth - textWidth) / 2;
                // Add the text to the document
                doc.text(text, textX, y);
            };

            const formatDate = (date) => {
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${month}/${day}/${year}`;
            };

            // Add company logo
            const logoImg = await fetch(logo);
            const logoBlob = await logoImg.blob();
            const logoURL = URL.createObjectURL(logoBlob);
            doc.addImage(logoURL, 'PNG', 10, 3, 70, 14.35); // Adjust position and dimensions as needed

            // Add document heading
            doc.setFontSize(14);
            centerText("Outstanding Balance Report - Per Product", 10, 'bold');

            if (endDate) {
                doc.setFontSize(12);
                centerText(`As of ${formatDate(endDate)}`, 19);
            }

            const tableColumn = ["Loan Product", "No. of Accounts", "Outstanding Balance"];
            const tableRows = [];

            response.data.loanProducts.forEach(product => {
                const rowData = [
                    product.loanProduct,
                    product.count,
                    product.remainingBalance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                ];
                tableRows.push(rowData);
            });

            tableRows.push([
                "Grand Total",
                response.data.loanProducts.reduce((total, product) => total + product.count, 0),
                response.data.totalRemainingBalance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            ]);

            // Get current timestamp and format it
            const now = new Date();
            const timestamp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
            doc.autoTable(tableColumn, tableRows, { startY: 30 }); // Adjust startY position as needed
            doc.save(`Outstanding_Balance_Per_Product_${timestamp}.pdf`); // Save with timestamp in filename
            setShowSpinner(false);
        } catch (error) {
            console.error('Error generating PDF:', error);
            setShowSpinner(false);
        }
    };

    const handleClick = (e) => {
        e.preventDefault();
        handleGeneratePDF();
    };

    return (
        <>
            {showSpinner && (<LoadingSpinner />)}
            <div className="filters-container">
                <div className="date-range-controls">
                    <label htmlFor="endDate">As of: </label>
                    <input
                        type="date"
                        id="endDate"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
                <Button href="#" className="generate-pdf-button" onClick={handleClick}>
                    <i className="fa-solid fa-print"></i> Export
                </Button>
            </div>
            
            {data && (
                <Table className="list-container" hover responsive>
                    <thead className="list-title">
                        <tr>
                            <th className="list-header-item">Loan Product</th>
                            <th className="list-header-item">No. of Accounts</th>
                            <th className="list-header-item">Outstanding Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.loanProducts.map((product, index) => (
                            <tr className="list-body" key={index}>
                                <td className="list-body-item">{product.loanProduct}</td>
                                <td className="list-body-item">{product.count}</td>
                                <td className="list-body-item">{<ToPeso amount={product.remainingBalance.toFixed(2)} />}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot className="last-align">
                        <tr>
                            <td>Grand Total</td>
                            <td>{data.loanProducts.reduce((total, product) => total + product.count, 0)}</td>
                            <td>{<ToPeso amount={data.totalRemainingBalance.toFixed(2)} />}</td>
                        </tr>
                    </tfoot>
                </Table>
            )}
        </>
    );
}

export default ReportOutstandingBalancePerProduct;
